/* eslint-disable react-hooks/exhaustive-deps */
import React, { useRef, useState } from 'react';
import './CSVStyle.scss';
import { useGetCompanyConfig, usePutCompanyConfig } from '../../hooks/useCompanies';
import { Button, Empty, Input, notification, Row, Space, Tag, Typography } from 'antd';
import Papa from 'papaparse';
import { PlusCircleOutlined, UploadOutlined } from '@ant-design/icons';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import AliasCard from './AliasCard';
import { FileDrop } from 'react-file-drop';
import useLogout from '../../hooks/useLogout';

const CSVConfig = ({ clientName, companyId }) => {
    const inputRef = useRef(null);
    const aliasInputRef = useRef(null);
    const onSuccess = data => {
        setCompanyConfigData(data);
    };
    useGetCompanyConfig(onSuccess, companyId);

    const [api, contextHolder] = notification.useNotification();
    const [sessionTags, setSessionTags] = useState([]);
    const [showAddTags, setShowAddTags] = useState(false);
    const [showAddAlias, setShowAddAlias] = useState(false);
    const [companyConfigData, setCompanyConfigData] = useState({});
    const { logout } = useLogout();
    const onUpdateCompanyConfig = resp => {
        api['success']({
            message: resp.data.message,
        });
    };
    const onUpdateConfigError = error => {
        if (error?.response?.status === 401) logout();
    };
    const { mutate: updateCompanyConfig } = usePutCompanyConfig(onUpdateCompanyConfig, onUpdateConfigError);
    const changeHandler = file => {
        Papa.parse(file, {
            header: true,
            skipEmptyLines: true,
            complete: function (results) {
                const rowsArray = [];
                results.data?.map(d => {
                    rowsArray.push(Object.keys(d));
                });
                setSessionTags(Array.from(new Set([...sessionTags, ...rowsArray[0]])));
            },
        });
    };
    const addTags = tag => {
        if (tag) {
            setSessionTags(Array.from(new Set([...sessionTags, tag])));
        }
        inputRef.current.input.value = ' ';
    };
    const handleRequiredCheck = (isChecked, index) => {
        let tempConfig = companyConfigData;
        tempConfig.columnHeaders[index].required = isChecked;
        setCompanyConfigData({ ...tempConfig });
    };
    const addAlias = title => {
        let duplicateValue = companyConfigData.columnHeaders.find(col => col.alias.toLowerCase() === title.toLowerCase());
        if (title && !duplicateValue) {
            let tempConfig = companyConfigData;
            if (!tempConfig.columnHeaders) tempConfig.columnHeaders = [];
            tempConfig.columnHeaders.push({
                name: [],
                alias: title,
                required: false,
            });
            setCompanyConfigData({ ...tempConfig });
        }
    };
    const handleRemoveColumn = index => {
        let tempConfig = companyConfigData;
        tempConfig.columnHeaders.splice(index, 1);
        setCompanyConfigData({ ...tempConfig });
    };
    const handleUpdateConfig = () => {
        updateCompanyConfig({ companyConfigObj: companyConfigData, companyId });
    };
    const onDragEnd = result => {
        if (result.destination) {
            let tempConfig = companyConfigData.columnHeaders;
            let targetIndex = parseInt(result.destination.droppableId);
            let draggedName = result.draggableId;
            tempConfig[targetIndex].name.push(draggedName);
            tempConfig[targetIndex].name = Array.from(new Set(tempConfig[targetIndex].name));
            setCompanyConfigData({ ...companyConfigData, columnHeaders: tempConfig });
        }
    };
    const handleClose = removedTag => {
        const NewSessionTags = sessionTags.filter(tag => tag !== removedTag);
        setSessionTags(NewSessionTags);
    };
    const handleRemoveName = (columnIndex, nameIndex) => {
        let tempConfig = companyConfigData.columnHeaders;
        let targetName = tempConfig[columnIndex].name[nameIndex];
        tempConfig[columnIndex].name = tempConfig[columnIndex].name.filter(name => name !== targetName);
        setCompanyConfigData({ ...companyConfigData, columnHeaders: tempConfig });
    };

    return (
        <>
            {contextHolder}
            <Typography.Title color="darkgray" level={5}>
                CSV Config for: {clientName}
            </Typography.Title>

            <Row className="container_box content_center" style={{ maxHeight: '95px' }}>
                <FileDrop onDrop={f => changeHandler(f[0])} className="full_width">
                    <div className="align_content_center content_center full_width">
                        <Typography.Text color="darkgray">Drop CSV Samples here</Typography.Text>

                        <div className="image-upload">
                            <label htmlFor="csvFile">
                                <UploadOutlined className="upload_icon" />
                            </label>
                            <input
                                type="file"
                                accept=".csv"
                                id="csvFile"
                                onChange={e => {
                                    changeHandler(e.target.files[0]);
                                }}
                            />
                        </div>
                    </div>
                </FileDrop>
            </Row>
            <Row className="csv_header">
                <Typography.Text strong>CSV header</Typography.Text>
                {!showAddTags ? (
                    <PlusCircleOutlined className="pointer" onClick={() => setShowAddTags(true)} />
                ) : (
                    <Space direction="horizontal">
                        <Input placeholder="Add CSV Header" allowClear size="small" ref={inputRef} />
                        <Button style={{ width: 80 }} size="small" onClick={e => addTags(inputRef.current.input.value.trim())}>
                            Add
                        </Button>
                    </Space>
                )}
            </Row>
            <DragDropContext onDragEnd={onDragEnd}>
                <Droppable droppableId="name">
                    {provided =>
                        sessionTags.length > 0 ? (
                            <Row className="container_box" style={{ maxHeight: '95px' }}>
                                <Space size={[0, 8]} wrap>
                                    {sessionTags?.map((tag, i) => (
                                        <div ref={provided.innerRef} {...provided.droppableProps} key={`${tag}${i}`}>
                                            <Draggable draggableId={tag} index={i}>
                                                {(provided, snapshot) => (
                                                    <div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                                                        <Tag
                                                            className="pointer"
                                                            // closable
                                                            // onClose={() => {
                                                            //   handleClose(tag);
                                                            // }}
                                                        >
                                                            {tag}
                                                            {provided.placeholder}
                                                        </Tag>
                                                    </div>
                                                )}
                                            </Draggable>
                                        </div>
                                    ))}
                                </Space>
                            </Row>
                        ) : (
                            <Row className="content_center container_box">
                                <Typography.Text type="secondary">No header to show</Typography.Text>
                            </Row>
                        )
                    }
                </Droppable>
                {/* )} */}
                <Row className="csv_header">
                    <Typography.Text strong></Typography.Text>
                    {!showAddAlias ? (
                        <PlusCircleOutlined className="pointer" onClick={() => setShowAddAlias(true)} />
                    ) : (
                        <Space direction="horizontal">
                            <Input placeholder="Add Alias" allowClear size="small" ref={aliasInputRef} />
                            <Button style={{ width: 80 }} size="small" onClick={e => addAlias(aliasInputRef.current.input.value.trim())}>
                                Add
                            </Button>
                        </Space>
                    )}
                </Row>
                {companyConfigData?.columnHeaders?.length > 0 ? (
                    <Row className="container_box">
                        {companyConfigData?.columnHeaders?.map((column, i) => (
                            <Droppable droppableId={`${i}`} index={i} key={i}>
                                {provided => (
                                    <div ref={provided.innerRef}>
                                        <AliasCard
                                            key={i}
                                            handleRemoveColumn={handleRemoveColumn}
                                            handleRequiredCheck={handleRequiredCheck}
                                            column={column}
                                            handleRemoveName={handleRemoveName}
                                            currentIndex={i}
                                        />
                                    </div>
                                )}
                            </Droppable>
                        ))}
                    </Row>
                ) : (
                    <Row className="content_center container_box">
                        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                    </Row>
                )}
            </DragDropContext>
            <Row className="button_container">
                <Button onClick={handleUpdateConfig}>Save</Button>
            </Row>
        </>
    );
};

export default CSVConfig;
